import { createSlice } from '@reduxjs/toolkit';
import { fetchWellTestData } from './../../dispatchers/WellTestDispatcher';

const initialState = {
  data: undefined,
  loading: false,
  error: undefined,
};

const TestWellDataSlice = createSlice({
  name: 'testWellDataSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWellTestData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWellTestData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWellTestData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setInitialState } = TestWellDataSlice.actions;

export default TestWellDataSlice.reducer;
